import React from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTE_PATH from 'routes/config';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { HeaderMainWrap } from './style';
import theme from '../../styles/theme';
import { useApp } from '../../contexts/AppContext';

const HeaderMain = ({ showBanner = false, onlyLogo = false }) => {
  const navigate = useNavigate();
  const { auth } = useApp();

  return (
    <HeaderMainWrap showBanner={showBanner} onlyLogo={onlyLogo}>
      <h1
        onClick={() => {
          navigate('/');
        }}
      >
        <img
          src={`/images/aizen/top-logo-new.png`}
          alt="Seller Credit Connect"
        />
      </h1>
      {!onlyLogo && (
        <div>
          <button
            type="button"
            className="btnLoan"
            onClick={() => {
              navigate(ROUTE_PATH.mypage.checkLoan);
            }}
          >
            대출 비교하기
          </button>
          {auth.authenticated ? (
            <button type="button">
              <FeatherIcon
                icon="menu"
                size={22}
                color={theme.color.grey3}
                onClick={() => {
                  navigate(ROUTE_PATH.mypage.main);
                }}
              />
            </button>
          ) : (
            <button type="button">
              <FeatherIcon
                icon="user"
                size={22}
                color={theme.color.grey3}
                onClick={() => {
                  navigate(ROUTE_PATH.mypage.main);
                }}
              />
            </button>
          )}
        </div>
      )}
    </HeaderMainWrap>
  );
};

export default HeaderMain;
